window.Products.Accessory.FaceMask = function() {};
window.Products.Accessory.FaceMask.inherits(window.Products.Accessory.Accessory);
window.Products.Accessory.FaceMask.id = 91;
window.Products.Accessory.FaceMask.slug = 'face-mask';
window.Products.Accessory.FaceMask.has_3d = true;
window.Products.Accessory.FaceMask.use_glb = true;
window.Products.Accessory.FaceMask.dpi = 150;

window.Products.Accessory.FaceMask.prototype.set3dProperties = function(modelViewer) {
	var me = this;

	me.loadEnvMap(function(){
		for(var i = 0; i < modelViewer.object.children.length; i++){
			if(!modelViewer.object.children[i].material) continue;
			modelViewer.object.children[i].material.aoMapIntensity = 2;
			modelViewer.object.children[i].material.envMap = me.envMap;
			modelViewer.object.children[i].material.envMap.mapping = THREE.EquirectangularReflectionMapping;
			modelViewer.object.children[i].material.needsUpdate = true;
			modelViewer.object.children[i].material.envMap.needsUpdate = true;
		}
		me.updateThreeTexture(modelViewer);
	});
};

window.Products.Accessory.FaceMask.prototype.setThreeControls = function(controls) {
	controls.minDistance = 0.7;
	controls.maxDistance = 2.0;
};

window.Products.Accessory.FaceMask.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[0].material.map = modelViewer.texture;
	modelViewer.object.children[0].material.map.flipY = false;
	modelViewer.object.children[0].material.needsUpdate = true;
};